import $ from "jquery"

// svgstore (manipulated by webpack plugin – can't do dynamic parameters)
window.baseUrl = '/local/dist/2020/';
//  import Bootstrap 
require('bootstrap');
// #####################
// ### current INDEX ###
require("./2020/index")
